import BlockFormatPluginFactory from '../Blocks/BlockFormatPluginFactory';
import BlockMarkdownPluginFactory from '../Blocks/BlockMarkdownPluginFactory';
import HeadersNormalizationsPlugin from './HeadersNormalizationsPlugin';

export const H1FormatPlugin = BlockFormatPluginFactory({
  type: 'h1',
  tag: 'h1',
  title: 'Heading 1',
  hasAnchor: true,
});

export const H2FormatPlugin = BlockFormatPluginFactory({
  type: 'h2',
  tag: 'h2',
  title: 'Heading 2',
  hasAnchor: true,
});

export const H3FormatPlugin = BlockFormatPluginFactory({
  type: 'h3',
  tag: 'h3',
  title: 'Heading 3',
  hasAnchor: true,
});

export const H4FormatPlugin = BlockFormatPluginFactory({
  type: 'h4',
  tag: 'h4',
  title: 'Heading 4',
  hasAnchor: true,
});

export const H5FormatPlugin = BlockFormatPluginFactory({
  type: 'h5',
  tag: 'h5',
  title: 'Heading 5',
  hasAnchor: true,
});

export const H6FormatPlugin = BlockFormatPluginFactory({
  type: 'h6',
  tag: 'h6',
  title: 'Heading 6',
  hasAnchor: true,
});

export const H1MarkdownPlugin = BlockMarkdownPluginFactory({
  type: 'h1',
  shortcut: '#',
  dependencies: [H1FormatPlugin],
});

export const H2MarkdownPlugin = BlockMarkdownPluginFactory({
  type: 'h2',
  shortcut: '##',
  dependencies: [H2FormatPlugin],
});

export const H3MarkdownPlugin = BlockMarkdownPluginFactory({
  type: 'h3',
  shortcut: '###',
  dependencies: [H3FormatPlugin],
});

export const H4MarkdownPlugin = BlockMarkdownPluginFactory({
  type: 'h4',
  shortcut: '####',
  dependencies: [H4FormatPlugin],
});

const HeadersPlugin = [
  H1FormatPlugin,
  H2FormatPlugin,
  H3FormatPlugin,
  H4FormatPlugin,
  H5FormatPlugin,
  H6FormatPlugin,
  H1MarkdownPlugin,
  H2MarkdownPlugin,
  H3MarkdownPlugin,
  H4MarkdownPlugin,
  ...HeadersNormalizationsPlugin,
];

export default HeadersPlugin;
